import Service 		from "./../../Libs/Service";
import Request 		from "./../../Libs/Service.Request";
import Socket		from "./../../Libs/Service.Socket";

import SetupSettings 					from "./../settings/settings.json";

import { Metadata } 					from "./Metadata";
import { User } 						from "./User";
import { Publisher } 					from "./Publisher";
import { Project } 						from "./Project";

let Server = new Service({

	Name: "Server",

	Libraries: [Request, Socket],

	Events: {

		"Socket Connection Established": function() {

			if (location.pathname.indexOf('/invitation/') === 0) {

				this.sendToSocket({
					Init: {
						Invitation: location.pathname.substr(12)
					}
				});

			} else {

				this.sendToSocket({
					Init: {}
				});

			}

			if (Publisher.SelectedPublisher) Layout.setPublisher(Publisher.SelectedPublisher.id);
			if (Project.SelectedProject) Layout.setProject(Project.SelectedProject.id);

		}

	},

	Actions: {

		'*': function(data, size) {

			console.info(`%c<<< SERVER DATA << ${Math.round(size / 1000)}kb <<`, 'color: #bada55', data);

			_.each(data, (value, key) => {

				Broadcast.call(`Server Data:${key}`, [value, data]);

			});

			setTimeout(() => {

				//Если получен текущий пользователь
				if (Metadata.loaded && User.loaded && Publisher.loaded && Project.isSelectedProjectLoaded() && !this.loaded) {

					this.loaded = true;

					Broadcast.call("Server Data Loaded");

				}

			}, 10);

		}

	},

	init() {

		this.loaded = false;

		this.timeouts = {};

		// global access needed sometimes for the debug purposes (do not use global SetupSettings object in the code)
		window.SetupSettings = SetupSettings;

	},

	connect() {

		if (location.protocol === 'https:') this.connectSocket(`wss://${SetupSettings["domain"]}/ws`);
		else this.connectSocket(`ws://${SetupSettings["domain"]}/ws`);

	},

	sendWithTimeout(data, timeoutKey = null, timeout = null, next = null) {

		if (!timeoutKey) timeoutKey = _.keys(data)[0];
		if (!timeout) timeout = 1000;

		clearTimeout(this.timeouts[timeoutKey]);
		this.timeouts[timeoutKey] = setTimeout(() => {

			Server.sendToSocket(data);

			if (next) next();

		}, timeout);

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Server) Server = window.Server;
else window.Server = Server;

export { Server }
